"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orange = {
  c10: '#421A00',
  c20: '#642B00',
  c30: '#873D00',
  c40: '#AD5000',
  c50: '#C85D00',
  c60: '#E76F00',
  c70: '#FF8C54',
  c80: '#FFC8B8',
  c90: '#FFECE8',
  c100: '#FFFFFF'
};